<mat-toolbar class="sobrado-toolbar"
             [class.sobrado-toolbar--insurer]="colorSchema.isInsurer">
  <div class="logo-container">
    <a [href]="getRedirectLink('')"
       [tabIndex]="0"
       [attr.aria-label]="'front.sng.title.sobrado_home_page' | translate">
      <i class="icon-image icon--logo"></i>
    </a>
  </div>

  <div class="menu-container"
       [class.menu-container--iframe]="isIframePage() || !hasAccessToken()">
    @if (isBrokerRole() || isBrokerPlatformMember) {
      @if ((isApplicationAdminOrLibraryAdmin() || isBrokerRole()) && isCngEnabled()) {
        <a class="btn--menu"
           [routerLink]="[LINK.BROKER_CALL_DASHBOARD_LINK_URL]"
           [class.btn--menu--active]="checkRouteUrl(LINK.BROKER_CALL_DASHBOARD_LINK_URL) || checkRouteUrl(LINK.BROKER_CALL_LINK_URL)"
           [tabIndex]="0">
          {{ 'front.sng.menu.dashboard' | translate }}
        </a>
      } @else {
        <a class="btn--menu"
           [href]="getRedirectLink(LINK.LINK_BROKER_DASHBOARD)"
           [tabIndex]="0">
          {{ 'front.sng.menu.dashboard' | translate }}
        </a>
      }
    }
    @if (isBrokerRole() || isLibraryAdmin() || isBrokerPlatformMember) {
      @let productsAttrs = getPlatformMemberAttrs(isBrokerPlatformMember);
      <button class="btn--menu"
              [type]="ButtonType.Button"
              [matMenuTriggerFor]="productsAttrs.disabled ? null : productsGccMenu"
              #productsGccMenuTarget="matMenuTrigger"
              [class.menu-open]="productsGccMenuTarget.menuOpen"
              [class.btn--menu--disabled]="productsAttrs.disabled"
              [class.btn--menu--active]="checkRouteUrl(LINK.LIBRARY_LINK_URL) || checkRouteUrl(LINK.TAB_INSURER_INTERVIEW)"
              [matTooltipDisabled]="productsAttrs.tooltipDisabled"
              [matTooltip]="productsAttrs.tooltip | translate"
              [tabIndex]="productsAttrs.tabIndex">
        <span>{{ 'front.sng.menu.products.gcc' | translate }}</span>
        <app-expand-icon [expanded]="productsGccMenuTarget.menuOpen" [size]="IconSize.Size16"></app-expand-icon>
      </button>
    }
    @if (isBrokerRole() || isBrokerPlatformMember) {
      @if (isCngEnabled() && !isBrokerPlatformMember) {
        <a class="btn--menu"
           [routerLink]="[LINK.CRM_OVERVIEW_LINK_URL]"
           [class.btn--menu--active]="checkRouteUrl(LINK.CRM_LINK_URL)"
           [tabIndex]="0">
          {{ 'front.sng.menu.organizations' | translate }}
        </a>
      } @else {
        @let crmAttrs = getPlatformMemberAttrs(isBrokerPlatformMember, LINK.LINK_CRM);
        <a class="btn--menu"
           [attr.href]="crmAttrs.href"
           [class.btn--menu--disabled]="crmAttrs.disabled"
           [class.btn--menu--active]="checkRouteUrl(LINK.LINK_CRM)"
           [matTooltipDisabled]="crmAttrs.tooltipDisabled"
           [matTooltip]="crmAttrs.tooltip | translate"
           [tabIndex]="crmAttrs.tabIndex">
          {{ 'front.sng.menu.organizations' | translate }}
        </a>
      }
      @let misAttrs = getMisAttrs();
      <a class="btn--menu"
         [attr.href]="misAttrs.href"
         [class.btn--menu--disabled]="misAttrs.disabled"
         [class.btn--menu--active]="checkRouteUrl(LINK.MIS_LINK_URL)"
         [matTooltipDisabled]="misAttrs.tooltipDisabled"
         [matTooltip]="misAttrs.tooltip | translate"
         [tabIndex]="misAttrs.tabIndex">
        {{ 'front.sng.title.mis' | translate }}
      </a>
      <div [matMenuTriggerFor]="hasSmartSubscription() ? null : smartSubTooltipMenu"
           #smartSubTooltipTrigger="matMenuTrigger"
           (mouseenter)="onTooltipMouseEnter(smartSubTooltipTrigger)"
           (mouseleave)="onTooltipMouseLeave(smartSubTooltipTrigger)">
        <a class="btn--menu"
           [class.btn--menu--disabled]="!hasSmartSubscription()"
           [attr.href]="getRedirectToGetMoreBrain()"
           [target]="'_blank'"
           [tabIndex]="smartButtonTabIndex">
          {{ 'front.sng.menu.smart_subscriptions' | translate }}
        </a>
      </div>
      <a class="btn--menu"
         [href]="getRedirectLink(LINK.LINK_NEWS)"
         [tabIndex]="0">
        {{ 'front.sng.menu.news' | translate }}
      </a>
    }
    @if (isInsurerRole() || isInsurerPlatformMember) {
      @let dashboardAttrs = getPlatformMemberAttrs(isInsurerPlatformMember, LINK.LINK_INSURER_DASHBOARD);
      <a class="btn--menu"
         [attr.href]="dashboardAttrs.href"
         [class.btn--menu--disabled]="dashboardAttrs.disabled"
         [class.btn--menu--active]="checkRouteUrl(LINK.LINK_INSURER_DASHBOARD)"
         [matTooltipDisabled]="dashboardAttrs.tooltipDisabled"
         [matTooltip]="dashboardAttrs.tooltip | translate"
         [tabIndex]="dashboardAttrs.tabIndex">
        {{ 'front.sng.menu.dashboard' | translate }}
      </a>
      @if (hasEntrypointDashboardOpsAccess()) {
        <a class="btn--menu"
           [routerLink]="[LINK.INSURER_ENTRYPOINT_DASHBOARD_LINK_URL]"
           [class.btn--menu--active]="checkRouteUrl(LINK.INSURER_ENTRYPOINT_DASHBOARD_LINK_URL)"
           [tabIndex]="0">
          {{ 'front.sng.menu.entrypoint' | translate }}
        </a>
      } @else {
        <a class="btn--menu"
           [href]="getRedirectLink(LINK.LINK_ENTRYPOINT)"
           [tabIndex]="0">
          {{ 'front.sng.menu.entrypoint' | translate }}
        </a>
      }
      @let marketplaceAttrs = getPlatformMemberAttrs(isInsurerPlatformMember, LINK.LINK_MARKETPLACE);
      <a class="btn--menu"
         [attr.href]="marketplaceAttrs.href"
         [class.btn--menu--disabled]="marketplaceAttrs.disabled"
         [class.btn--menu--active]="checkRouteUrl(LINK.LINK_MARKETPLACE)"
         [matTooltipDisabled]="marketplaceAttrs.tooltipDisabled"
         [matTooltip]="marketplaceAttrs.tooltip | translate"
         [tabIndex]="marketplaceAttrs.tabIndex">
        {{ 'front.sng.menu.marketplace' | translate }}
      </a>
      @let libraryAttrs = getPlatformMemberAttrs(isInsurerPlatformMember);
      <button class="btn--menu"
              [type]="ButtonType.Button"
              [matMenuTriggerFor]="libraryAttrs.disabled ? null : insurerLibraryMenu"
              #insurerLibraryMenuTarget="matMenuTrigger"
              [class.menu-open]="insurerLibraryMenuTarget.menuOpen"
              [class.btn--menu--disabled]="libraryAttrs.disabled"
              [class.btn--menu--active]="checkRouteUrl(LINK.LIBRARY_LINK_URL) || checkRouteUrl(LINK.TAB_INSURER_INTERVIEW)"
              [matTooltipDisabled]="libraryAttrs.tooltipDisabled"
              [matTooltip]="libraryAttrs.tooltip | translate"
              [tabIndex]="libraryAttrs.tabIndex">
        <span>{{ 'front.sng.menu.library' | translate }}</span>
        <app-expand-icon [expanded]="insurerLibraryMenuTarget.menuOpen" [size]="IconSize.Size16"></app-expand-icon>
      </button>
      <button class="btn--menu"
              [type]="ButtonType.Button"
              [matMenuTriggerFor]="moreInsurerMenu"
              #moreInsurerMenuTarget="matMenuTrigger"
              [class.menu-open]="moreInsurerMenuTarget.menuOpen"
              [tabIndex]="0">
        <span> {{ 'front.sng.menu.more' | translate }}</span>
        <app-expand-icon [expanded]="moreInsurerMenuTarget.menuOpen" [size]="IconSize.Size16"></app-expand-icon>
      </button>
    }
    <button [type]="ButtonType.Button" [matMenuTriggerFor]="langMenu"
            class="btn--menu btn--menu--icon mat-button--lang-menu"
            #langMenuTarget="matMenuTrigger"
            [class.active]="langMenuTarget.menuOpen"
            [tabIndex]="0">
      <span class="lang-icon">
        <mat-icon class="icon--size--16">language</mat-icon>
      </span>
      <span class="lang-title">{{ getSelectedLang() }}</span>
      <span class="arrow">
        <app-expand-icon [expanded]="langMenuTarget.menuOpen" [size]="IconSize.Size16"></app-expand-icon>
      </span>
    </button>
    <mat-menu #langMenu="matMenu" class="mat-menu--lang-menu">
      @for (lang of langList; track lang) {
        <button mat-menu-item
                [class.selected]="lang === getSelectedLang()"
                [tabIndex]="0"
                (click)="setTransLanguage(lang)">
          {{ lang }}
        </button>
      }
    </mat-menu>
    @if (hasAccessToken()) {
      <button class="btn--menu btn--menu--icon"
              [type]="ButtonType.Button"
              [disabled]="isPlatformMember"
              [tabIndex]="tabIndex"
              [attr.aria-label]="'front.sng.button.search' | translate">
        <mat-icon class="search-icon icon--size--16">search</mat-icon>
      </button>
      <button class="btn--menu btn--menu--icon"
              [type]="ButtonType.Button"
              [disabled]="isPlatformMember"
              [tabIndex]="tabIndex"
              [attr.aria-label]="'front.sng.title.notifications' | translate">
        <mat-icon class="icon--size--16">notifications</mat-icon>
      </button>
    }
  </div>

  @if (hasAccessToken()) {
    <div class="profile-container">

      <button mat-button
              [type]="ButtonType.Button"
              [matMenuTriggerFor]="userMenu"
              (menuOpened)="loadDeputies()"
              class="mat-button--user-menu"
              #userMenuTarget="matMenuTrigger"
              [class.active]="userMenuTarget.menuOpen"
              [class.mat-button--user-menu--insurer]="colorSchema.isInsurer"
              [tabIndex]="0">
        <app-user-avatar class="avatar"></app-user-avatar>
        <span class="title">
          <span class="company">
            <span>{{ getCurrentRoleName() }}</span>
            <mat-icon class="icon--color--broker icon--size--16">expand_more</mat-icon>
          </span>
          <span class="name">{{ getFullName() }}</span>
        </span>
      </button>

      <mat-menu #userMenu="matMenu" class="mat-menu--user-menu {{colorSchema.menuPanelClass}}">
        @if (!isGuestRole()) {
          <h3 class="title">{{ 'front.sng.title.settings' | translate }}</h3>
          <a mat-menu-item
             [href]="getRedirectLink(LINK.LINK_ACCOUNT)"
             [disabled]="isPlatformMember"
             [tabIndex]="0">
            <app-user-avatar class="icon-container" [size]="UserAvatarSize.Small"></app-user-avatar>
            <span class="title">{{ 'front.sng.menu.personal' | translate }}</span>
          </a>
        }
        @if (isBrokerAdmin()) {
          <a mat-menu-item
             [href]="getRedirectLink(LINK.LINK_PERSONAL_SETTINGS)"
             [tabIndex]="0">
            <span class="icon-container">
              <mat-icon class="icon--size--16">business_center</mat-icon>
            </span>
            <span class="title">{{ 'front.sng.menu.company' | translate }}</span>
          </a>
          <a mat-menu-item
             [href]="getRedirectLink(LINK.LINK_COMPANY_SETTINGS)"
             [tabIndex]="0">
            <span class="icon-container">
              <i class="icon icon--insurers icon--size--16"></i>
            </span>
            <span class="title">{{ 'front.sng.menu.insurers' | translate }}</span>
          </a>
        }
        @if (isInsurerAdmin()) {
          <a mat-menu-item
             [href]="getRedirectLink(LINK.LINK_INSURER_SETTINGS_COMPANY)"
             [tabIndex]="0">
            <span class="icon-container">
              <mat-icon class="icon--size--16">business_center</mat-icon>
            </span>
            <span class="title">{{ 'front.sng.menu.company' | translate }}</span>
          </a>
          <a mat-menu-item
             [href]="getRedirectLink(LINK.LINK_INSURER_SETTING_USER_ACCOUNTS)"
             [tabIndex]="0">
            <span class="icon-container">
              <i class="icon icon--insurers icon--size--16"></i>
            </span>
            <span class="title">{{ 'front.sng.menu.user.accounts' | translate }}</span>
          </a>
        }
        <mat-divider></mat-divider>
        @if (isApplicationAdminOrLibraryAdmin()) {
          <a mat-menu-item
             [routerLink]="[LINK.ADMIN_LINK_URL]"
             [class.btn--menu--active]="checkAdminUrl()"
             [tabIndex]="0">
            <span class="icon-container">
              <mat-icon class="icon--size--16">admin_panel_settings</mat-icon>
            </span>
            <span class="title">{{ 'front.sng.title.admin.panel' | translate }}</span>
          </a>
          <mat-divider></mat-divider>
        }
        <div mat-menu-item class="item-menu--log-out" [disableRipple]="true">
          <button mat-stroked-button
                  [tabIndex]="0"
                  (click)="logout()">
            {{ 'front.sng.menu.log.out' | translate }}
          </button>
        </div>
        @if (isCallDashboardPage()) {
          @if (isInDeputyContext()) {
            <a mat-menu-item
               [tabIndex]="0"
               (click)="goBackToMyDashboard()">
              <span>{{ 'front.sng.menu.go_back_to_my_dashboard' | translate }}</span>
            </a>
          }
          @if (deputiesLoading() || hasDeputies()) {
            <mat-divider></mat-divider>
            <h3 class="title">{{ 'front.sng.menu.my_deputies' | translate }}</h3>
            @if (deputiesLoading()) {
              <div class="loading">
                <app-spinner [size]="SpinnerSize.Small"></app-spinner>
              </div>
            } @else {
              @for (deputy of deputies(); track deputy.id) {
                <a mat-menu-item
                   [tabIndex]="0"
                   (click)="switchToDeputy(deputy)">
                  <span>{{ deputy | deputyName }}</span>
                </a>
              }
            }
          }
        }
      </mat-menu>

    </div>
  }
</mat-toolbar>

<mat-menu #productsGccMenu="matMenu" class="mat-menu--user-menu {{colorSchema.menuPanelClass}}">

  @if (!isLibraryAdmin()) {
    <a mat-menu-item
       [routerLink]="[redirectLinkToLibrary(LINK.TAB_ACTIVITY_FEED)]"
       [routerLinkActive]="['btn--menu--active']"
       [tabIndex]="0">
      <span>{{ 'front.sng.menu.activity_feed' | translate }}</span>
    </a>
  }

  <a mat-menu-item
     [routerLink]="[redirectLinkToLibrary(LINK.TAB_GCC_DOCUMENTS)]"
     [routerLinkActive]="['btn--menu--active']"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.gcc.documents' | translate }}</span>
  </a>
  <a mat-menu-item
     [routerLink]="[redirectLinkToLibrary(LINK.TAB_INSURER_INTERVIEWS)]"
     [routerLinkActive]="['btn--menu--active']"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.insurer.interviews' | translate }}</span>
  </a>

  @if (hasInterPensionAccess()) {
    <a mat-menu-item
       [routerLink]="[redirectLinkToLibrary(LINK.TAB_INSURER_INTERVIEWS_INTER_PENSION)]"
       [routerLinkActive]="['btn--menu--active']"
       [tabIndex]="0">
      <span>{{ 'front.sng.title.inter-pension' | translate }}</span>
    </a>
  }

  @if (!isLibraryAdmin()) {
    <a mat-menu-item
       [routerLink]="[redirectLinkToLibrary(LINK.TAB_FURTHER_DOCUMENT)]"
       [routerLinkActive]="['btn--menu--active']"
       [tabIndex]="0">
      <span>{{ 'front.sng.menu.further.document' | translate }}</span>
    </a>
    <a mat-menu-item [href]="getRedirectLink(LINK.SOBRADO_BSSC_BROKER)">
      <span>{{ 'front.sng.menu.bssc' | translate }}</span>
    </a>

    @if (isFactsheetEnabled()) {
      <a mat-menu-item
         [routerLink]="[redirectLinkToLibrary(LINK.TAB_FACTSHEET)]"
         [routerLinkActive]="['btn--menu--active']"
         [tabIndex]="0">
        <span>{{ 'front.sng.tab.factsheet' | translate }}</span>
      </a>
    }
    @if (isPensionReportEnabled()) {
      <a mat-menu-item
         [routerLink]="[redirectLinkToLibrary(LINK.TAB_PENSION_REPORT)]"
         [routerLinkActive]="['btn--menu--active']"
         [tabIndex]="0">
        <span>{{ 'front.sng.tab.pension_report' | translate }}</span>
      </a>
    }
  }
</mat-menu>

<mat-menu #insurerLibraryMenu="matMenu" class="mat-menu--user-menu {{colorSchema.menuPanelClass}}">
  <a mat-menu-item
     [routerLink]="[redirectLinkToLibrary(LINK.TAB_ACTIVITY_FEED)]"
     [routerLinkActive]="['btn--menu--active']"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.activity_feed' | translate }}</span>
  </a>
  <a mat-menu-item
     [routerLink]="[redirectLinkToLibrary(LINK.TAB_GCC_DOCUMENTS)]"
     [routerLinkActive]="['btn--menu--active']"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.gcc.documents' | translate }}</span>
  </a>
  <a mat-menu-item
     [routerLink]="[redirectLinkToLibrary(LINK.TAB_INSURER_INTERVIEWS)]"
     [routerLinkActive]="['btn--menu--active']"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.insurer.interviews' | translate }}</span>
  </a>
  @if (hasInterPensionAccess()) {
    <a mat-menu-item
       [routerLink]="[redirectLinkToLibrary(LINK.TAB_INSURER_INTERVIEWS_INTER_PENSION)]"
       [routerLinkActive]="['btn--menu--active']"
       [tabIndex]="0">
      <span>{{ 'front.sng.title.inter-pension' | translate }}</span>
    </a>
  }
  <a mat-menu-item
     [routerLink]="[redirectLinkToLibrary(LINK.TAB_FURTHER_DOCUMENT)]"
     [routerLinkActive]="['btn--menu--active']"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.further.document' | translate }}</span>
  </a>
  <a mat-menu-item
     [href]="getRedirectLink(LINK.SOBRADO_BSSC__INSURER)"
     [tabIndex]="0">
    <span>{{ 'front.sng.menu.bssc' | translate }}</span>
  </a>
  @if (hasTabProductManagement()) {
    <a mat-menu-item
       [routerLink]="[redirectLinkToLibrary(LINK.TAB_PRODUCT_MANAGEMENT)]"
       [routerLinkActive]="['btn--menu--active']"
       [tabIndex]="0">
      <span>{{ 'front.sng.title.own_insurer_interview' | translate }}</span>
    </a>
    <a mat-menu-item
       [href]="getRedirectLink(LINK.SOBRADO_INSURER_PRODUCTS__INSURER)"
       [tabIndex]="0">
      <span>{{ 'front.sng.title.insurer_products' | translate }}</span>
    </a>
  }
  @if (hasInsurerLibraryAccess()) {
    @if (isFactsheetEnabled()) {
      <a mat-menu-item
         [routerLink]="[redirectLinkToLibrary(LINK.TAB_FACTSHEET)]"
         [routerLinkActive]="['btn--menu--active']"
         [tabIndex]="0">
        <span>{{ 'front.sng.tab.factsheet' | translate }}</span>
      </a>
    }
    @if (isPensionReportEnabled()) {
      <a mat-menu-item
         [routerLink]="[redirectLinkToLibrary(LINK.TAB_PENSION_REPORT)]"
         [routerLinkActive]="['btn--menu--active']"
         [tabIndex]="0">
        <span>{{ 'front.sng.tab.pension_report' | translate }}</span>
      </a>
    }
  }
</mat-menu>

<mat-menu #moreInsurerMenu="matMenu" class="mat-menu--user-menu {{colorSchema.menuPanelClass}}">
  @for (item of insurerMenuItems; track item) {
    <div [matTooltip]="platformMemberTooltip | translate"
         [matTooltipDisabled]="!isInsurerPlatformMember">
      <a mat-menu-item
         [href]="getRedirectLink(item.link)"
         [class.btn--menu--active]="item.activeRoute && checkRouteUrl(item.activeRoute)"
         [disabled]="isInsurerPlatformMember"
         [tabIndex]="0">
        {{ item.translationKey | translate }}
      </a>
    </div>
  }
  <div [matMenuTriggerFor]="hasSmartSubscription() ? null : smartSubTooltipMenu"
       #smartSubInsTooltipTrigger="matMenuTrigger"
       (mouseenter)="onTooltipMouseEnter(smartSubInsTooltipTrigger)"
       (mouseleave)="onTooltipMouseLeave(smartSubInsTooltipTrigger)">
    <a mat-menu-item
       [href]="getRedirectToGetMoreBrain()"
       [disabled]="!hasSmartSubscription()"
       [target]="'_blank'"
       [tabIndex]="smartButtonTabIndex">
      {{ 'front.sng.menu.smart_subscriptions' | translate }}
    </a>
  </div>

  <a mat-menu-item
     [href]="getRedirectLink(LINK.LINK_NEWS)"
     [tabIndex]="0">
    {{ 'front.sng.menu.news' | translate }}
  </a>
</mat-menu>

<mat-menu #smartSubTooltipMenu="matMenu"
          class="mat-menu--tooltip mat-menu--tooltip--interactive"
          [hasBackdrop]="false"
          [overlapTrigger]="false">
  <div class="mat-panel--content"
       (mouseenter)="onTooltipContentMouseEnter()"
       (mouseleave)="onTooltipContentMouseLeave()">
    <div [innerHTML]="decodedSmartSubTooltip()"></div>
  </div>
</mat-menu>
